<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-sync"
          :text="$t('ui.refresh')"
          type="button"
          @click="getTurnoverTierList()"
          variant="primary"
          size="sm"
        )
      .form-group.col-12(v-if="isEditAccess")
        b-button(type="button" variant="info" size="sm" v-b-modal.addTurnoverTier v-if="totalRow < 10")
          i.fa.fa-lg.fa-plus
          span.ml-1 {{ $t("ui.combine.add_turnover_tier") }}
  .card-body
    .row
      .col-md-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="5%")
                  span #
                th.text-right(width="10%")
                  span(:title="$t('ui.turnover')") {{ $t("ui.turnover") }}
                th.text-right(width="10%")
                  span(:title="$t('ui.rebate_rate')") {{ $t("ui.rebate_rate") }}
                th.text-center(width="10%" v-if="isEditAccess") 
                  span(:title="$t('ui.action')") {{ $t("ui.action") }}
                th.text-right(width="10%")
                  span(:title="$t('ui.action_by')") {{ $t("ui.action_by") }}
                th.text-right(width="10%")
                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
            tbody.clusterize-content
              tr(v-if="turnoverTierList.length == 0")
                td(colspan="6").text-center
                  span {{ $t('message.no_data_available') }}
              tr(
                v-for="(item, index) in turnoverTierList"
              )
                td.text-center
                  span(:title="index + 1") {{ index + 1 }}
                td.text-right
                  span(:title="$n(item.turnover, 'currency')") {{ item.turnover != null ? $n(item.turnover, 'currency') : null }}
                td.text-right
                  span(:title="item.rebate_rate") {{ item.rebate_rate }}
                td.text-center(v-if="isEditAccess")
                  span
                    a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onEditTurnoverTier(item)" :title="$t('ui.edit_turnover_tier')")
                  span.ml-2
                    a.fa.fa-trash.btn.btn-ssm.btn-icon.btn-danger(href="javascript:void(0)" @click="confirmDeleteTurnoverTier(item)" :title="$t('ui.delete_turnover_tier')")
                td.text-right
                  span(:title="item.modified_by") {{ item.modified_by ? item.modified_by : "-" }}
                  br
                  span(:title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ item.modified_date ? $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') : "-" }}
                td.text-right
                  span(:title="item.created_by") {{ item.created_by ? item.created_by : "-" }}
                  br
                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ item.created_date ? $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') : "-" }}

    addturnovertier(@clicked="addTurnoverTier" @failed="handleFailed")
    editturnovertier(ref="editturnovertier" :item="selectedTurnoverTier"  @clicked="afterEditTurnoverTier" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import editproviderrtp from "@/components/setup/editProviderRtp.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import addturnovertier from "@/components/turnovertier/addTurnoverTier.vue";
import editturnovertier from "@/components/turnovertier/editTurnoverTier.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addturnovertier,
    editturnovertier
  },
  data: () => ({
    loading: false,
    selected: [],
    turnoverTierList: [],
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    selectedTurnoverTier: null
  }),
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    
    isEditAccess() {
      return this.$helpers.showActionButton("e_turnovertier");
    }
  },
  mounted: function() {
    // this.getTurnoverTierList();
  },
  methods: {
    refresh() {
      this.getTurnoverTierList()
    },
    onEditTurnoverTier: function(e) {
      this.selectedTurnoverTier = e;
      this.$refs.editturnovertier.$refs.editTurnoverTier.show();
    },
    afterEditTurnoverTier: function() {
      this.getTurnoverTierList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_turnover_tier"), this.$t("message.success"), "success");
    },
    addTurnoverTier: function() {
      this.getTurnoverTierList();
      this.$helpers.showDialog(this.$t("ui.combine.add_turnover_tier"), this.$t("message.success"), "success");
    },
    getTurnoverTierList: function() {
      this.getTurnoverTierCount();
      let url = config.turnoverTierListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.turnoverTierList = response.data.dt;
                // if (response.data.dt.length > 0) {
                //   this.turnoverTierList = response.data.dt;
                // }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    confirmDeleteTurnoverTier: function(e) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.delete_turnover_tier_confirm", { name: e.turnover }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.deleteTurnoverTier(e);
          } else {
            this.getTurnoverTierList();
          }
        });
    },
    deleteTurnoverTier: function(e) {
      let url = config.turnoverTierDeleteUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        tier_id: e.id,
      };

      this.feedback.success = true;
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getTurnoverTierList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getTurnoverTierCount: function() {
      let url = config.turnoverTierCountUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.totalRow = response.data.dt.length > 0 ? response.data.dt[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>